import * as Sentry from "@sentry/react";

/**
 * Captures an error in Sentry with feature and method and the context data
 * @param error - The error to capture
 * @param feature - The feature/module name ("chat", "post", "mymcloud")
 * @param method - The method/function name where the error occurred
 * @param extra - Additional context data
 * @param scope - Optional sub-scope ("list", "messaging", "polling", "upload")
 */
export const captureError = (
  error: unknown,
  feature: string,
  method: string,
  extra?: Record<string, unknown>,
  scope?: string
) => {
  const errorObj = error instanceof Error ? error : new Error(String(error));

  Sentry.captureException(errorObj, {
    tags: {
      feature,
      method,
      ...(scope && { scope })
    },
    extra: {
      ...extra,
      originalError: errorObj.message
    }
  });
};
